import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Small trick for seamless base64 password storage in django",
  "description": "",
  "published": "2010-07-14T00:00:00.000Z",
  "redirect_from": ["/blog/small-trick-for-seamless-base64-password-storage-in-django/swizec/1378"],
  "categories": "Application programming interface, django, Encryption, OAuth, Password, python, Security, Shareware, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Oauth_logo.svg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/08/300px-Oauth_logo.svg_.png",
              "alt": "OAuth logo",
              "title": "OAuth logo"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Oauth_logo.svg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`These days even the noobiest of the noobs know that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Password",
        "title": "Password"
      }}>{`passwords`}</a>{` should never be stored in plain-tect on the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Server_%28computing%29",
        "title": "Server (computing)"
      }}>{`server`}</a>{`. For various good and bad reasons, but the gist of it is `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Security_through_obscurity",
        "title": "Security through obscurity"
      }}>{`security through obscurity`}</a>{`.`}</p>
    <p>{`What a few less people know is that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Base64",
        "title": "Base64"
      }}>{`base64`}</a>{` is the same as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Plaintext",
        "title": "Plaintext"
      }}>{`plaintext`}</a>{`. Not only is it a very simple two way hashing function, if it can be called that, it's certainly not `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Encryption",
        "title": "Encryption"
      }}>{`encryption`}</a>{`, what's worse is that any coder worth their salt can recognise base64 encoding at a glance. Decoding it is trivial, many tools online can do it.`}</p>
    <p>{`On top of all of that, django already stores its user's passwords very securily with one-way hashing AND `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Salt_%28cryptography%29",
        "title": "Salt (cryptography)"
      }}>{`salting`}</a>{`.`}</p>
    <p>{`So what the fuck am I doing trying to save passwords in base64?`}</p>
    <h3 {...{
      "id": "problem"
    }}>{`Problem`}</h3>
    <p>{`The reason is in fact quite simple: External `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Application_programming_interface",
        "title": "Application programming interface"
      }}>{`API`}</a>{`'s.`}</p>
    <p>{`Here's the problem: what do you do when your service is accessing a third party API, which doesn't support `}<a parentName="p" {...{
        "href": "http://oauth.net",
        "title": "OAuth"
      }}>{`OAuth`}</a>{` or OAuth is impractical in your situation for various reasons and the API doesn't support some other means of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Login",
        "title": "Login"
      }}>{`logging in`}</a>{` with a hashed password. Basically, the only way you can access this API is if you know the user's password?`}</p>
    <p>{`The obvious solution is to fuck it and store plain-text passwords. Nothing you can do right? Hopefully nobody will hack your database and get to the passwords.`}</p>
    <p>{`Sure. But what when you're browsing around for debugging purposes? How do you prevent yourself from accidentally reading someone's password?`}</p>
    <h3 {...{
      "id": "solution"
    }}>{`Solution`}</h3>
    <p>{`That's where base64 comes in.`}</p>
    <p>{`But since we don't want to make our code silly, here's a simple way of achieving this without ever having to worry about it again.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`class PasswordManager(models.Manager):
    use_for_related_fields = True

    def create(self, *args, **kwargs):
        try:
            kwargs['password'] = base64.encodestring(kwargs['password'])
        except KeyError:
            pass

        return super(PasswordManager, self).create(*args, **kwargs)

    def get(self, *args, **kwargs):
        data = super(PasswordManager, self).get(*args, **kwargs)
        try:
            data.password = base64.decodestring(data.password)
        except AttributeError:
            pass
        return data

class GoogleAccount(models.Model):
    user = models.ForeignKey(User, unique=True)
    email = models.CharField(max_length=255)
    password = models.CharField(max_length=255)

    objects = PasswordManager()
`}</code></pre>
    <p>{`Basically we write a module manager that encodes all passwords in insert queries to base64 and decodes them again on select queries. For completeness sake it's also good to define a `}<em parentName="p">{`filter`}</em>{` function where we perform the decoding on the whole set of returned entries. But for this sort of thing that's rarely needed because you're rarely going to be performing third party actions for miriads of users at once.`}</p>
    <p>{`This way we achieve perfectly seamless base64 storage of passwords. Nice and easy.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=eded0a7d-aadf-4552-a54d-328c43c8a709",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      